// 초기화면 — 로그인 직후 또는 프로젝트명 클릭 시 표시
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function HomePage() {
  const navigate = useNavigate();

  return (
    <div style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      userSelect: 'none',
    }}>
      <p style={{
        margin: 0,
        fontSize: 24,
        fontWeight: 500,
        color: '#c0c4d0',
        lineHeight: 1.7,
        textAlign: 'center',
        letterSpacing: '-0.3px',
      }}>
        과한 욕심을 버리자!<br />
        지금도 충분하다.
      </p>
      <button
        onClick={() => navigate('/mobile/dashboard')}
        style={{
          marginTop: 24,
          padding: '8px 24px',
          background: 'transparent',
          border: '1px solid #d0d4de',
          borderRadius: 6,
          fontSize: 13,
          color: '#b0b4c0',
          cursor: 'pointer',
          transition: 'color 0.2s, border-color 0.2s',
          letterSpacing: '-0.2px',
        }}
        onMouseEnter={e => {
          e.currentTarget.style.color = '#888ca0';
          e.currentTarget.style.borderColor = '#a0a4b0';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.color = '#b0b4c0';
          e.currentTarget.style.borderColor = '#d0d4de';
        }}
      >
        모바일 화면 이동
      </button>
    </div>
  );
}
